/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable react-hooks/rules-of-hooks */

import axios from "axios";
export const getStaticFile = (token) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  return axios.get(
    "https://sso.forgedrift.com/api/getUploadedContentUrl?filename=layouts",
    config
  );
};

export const createStaticLayouts = (data, token) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  const formData = new FormData();
  formData.append("file", new Blob([JSON.stringify(data)]), "layouts");
//   formData.append("accessLevel", "global");
  return axios.put(
    "https://sso.forgedrift.com/api/uploadContent",
    formData,
    config
  );
};

// export const getSavedLayouts = async (token) => {
//   try {
//     const res = await getStaticFile(token);
//     if (res.data && res.data.response && res.data.response.url) {
//       const file = await axios.get(res.data.response.url);
//       return file;
//     }
//   } catch (error) {
//     return error;
//   }
// };

export const getSavedLayouts = async (pageName) => {
  try {
    console.log('token2');
    let token = 'Bearer '+localStorage.getItem("accessToken");
    console.log(token);
    console.log('before res');
    let res = await window.WizzUtils.pref.getTenantConfigs({token:token, type: pageName})
    console.log('after res',res);
    if (res && typeof res === 'object' && Object.keys(res).length > 0) {
      console.log('ok',Object.values(res));
      return Object.values(res); // Returns an array of objects [res[0], res[1], ...]

    }
    else
    {
      console.log('Not ok');
      return null;
    }
    
  } catch (error) {
    return error;
  }
};